// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1kmFy","error":"Textarea_error__3vuDn","readonly":"Textarea_readonly__30Tta","disabled":"Textarea_disabled__2Y62G"};